<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("ticker.menu.styles") }}</template>
        <template #sidebarMain>
            <div>
                <c-themes
                    :styleTheme="ticker.styleTheme"
                    :theme="ticker.theme"
                    @updateStyle="updateStyle($event)"
                    @updateColors="updateColors($event)"
                    @createTheme="createThemeFromTicker"
                />
                <CardToggle :title="$t('shared.general')">
                    <div class="space-y-5">
                        <FormSelect
                            v-if="googleFonts?.length"
                            v-model="ticker.fontFamily"
                            :label="$t('shared.font_family')"
                            :options="googleFonts"
                            :value="ticker.fontFamily"
                        />
                    </div>
                </CardToggle>
                <CardToggle :title="$t('shared.colors.title')">
                    <div class="space-y-5">
                        <FormInputColor
                            :title="$t('shared.colors.background')"
                            :model-value="ticker.colors.background"
                            @update:model-value="changeColor('background', $event)"
                            :tooltip="$t('shared.select_color_info')"
                        />
                        <FormInputColor
                            :title="$t('shared.colors.text')"
                            :model-value="ticker.colors.text"
                            @update:model-value="changeColor('text', $event)"
                            :tooltip="$t('shared.select_color_info')"
                        />
                        <FormInputColor
                            :title="$t('shared.colors.card_background')"
                            :model-value="ticker.colors.cardBackground"
                            @update:model-value="changeColor('cardBackground', $event)"
                            :tooltip="$t('shared.select_color_info')"
                        />
                        <FormInputColor
                            :title="$t('shared.colors.card_text')"
                            :model-value="ticker.colors.cardText"
                            @update:model-value="changeColor('cardText', $event)"
                            :tooltip="$t('shared.select_color_info')"
                        />
                        <FormInputColor
                            :title="$t('shared.colors.border')"
                            :model-value="ticker.colors.border"
                            @update:model-value="changeColor('border', $event)"
                            :tooltip="$t('shared.select_color_info')"
                        />
                    </div>
                </CardToggle>
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { PageSidebar } from "@easy/ui/page-components";
import { CardToggle } from "@easy/ui/cards";
import { FormInputColor, FormSelect } from "@easy/ui/forms";
import {
    updateTickerColors,
    updateTickerStyle,
    resetProjectTheme,
} from "@/shared/themes/updateTheme";
import { mapActions, mapState } from "vuex";
import cThemes from "@/shared/components/cThemes.vue";
import cSaveButton from "@/shared/components/cSaveButton.vue";

export default {
    name: "SidebarStyles",
    components: {
        CardToggle,
        FormInputColor,
        FormSelect,
        cThemes,
        PageSidebar,
        cSaveButton,
    },
    computed: {
        ...mapState({
            googleFonts: (f) => f.googleFonts.map((label) => ({ label, value: label })),
        }),
        ...mapState("ticker", ["ticker", "hasChanges"]),
    },
    async mounted() {
        await this.getFonts();
    },
    methods: {
        ...mapActions(["getFonts"]),
        ...mapActions("theme", ["createTheme"]),
        ...mapActions("ticker", ["saveSnapshot"]),
        changeColor(name, color) {
            this.ticker.colors[name] = color;
            resetProjectTheme({ project: this.ticker });
        },
        updateStyle(style) {
            updateTickerStyle({ ticker: this.ticker, style });
        },
        updateColors({ theme }) {
            updateTickerColors({ ticker: this.ticker, theme });
        },
        async createThemeFromTicker(name) {
            const { fontFamily: font, colors = {} } = this.ticker;
            const { text, cardText, cardBackground, border, background } = colors;
            const newTheme = await this.createTheme({
                name,
                font,
                colors: {
                    background,
                    border,
                    cardBackground,
                    cardText,
                    text,
                },
            });
            this.ticker.theme = String(newTheme.id);
        },
    },
};
</script>
